import Carousel from "@/components/ui/carousel/carousel";
import { SwiperSlide } from "swiper/react";
const data = [
  {
    id: "01",
    title: "Embrace Change",
    description:
      "Embrace Change symbolizes our commitment to innovation and adaptability, ensuring we stay ahead in an ever-evolving industry.",
  },
  {
    id: "02",
    title: "Chalta Hai Nahi Chalega",
    description:
      "We reject mediocrity and strive for the highest standards in everything we do, emphasising our dedication to excellence and precision.",
  },
  {
    id: "03",
    title: "Delivering Wow",
    description:
      "Commitment to exceeding customer expectations with exceptional and memorable experiences",
  },
  {
    id: "04",
    title: "Radical Candor",
    description:
      "We believe in giving and receiving feedback that is both caring and clear, driving continuous improvement.",
  },
  {
    id: "05",
    title: "Do it right the first time",
    description:
      "Commitment to precision and quality, ensuring that every task is completed correctly from the outset",
  },
  {
    id: "06",
    title: "Fire Your Boss",
    description:
      "We encourage autonomy and empowerment, inspiring team members to take ownership and lead initiatives.",
  },
];
const breakpoints = {
  1080: {
    slidesPerView: 3.4,
    spaceBetween: 0,
    slidesOffsetBefore: 32,
    slidesOffsetAfter: 32,
  },
  991: {
    slidesPerView: 2.4,
    spaceBetween: 0,
    slidesOffsetBefore: 32,
    slidesOffsetAfter: 32,
  },
  // when window width is >= 768px
  768: {
    slidesPerView: 2.2,
    spaceBetween: 0,
    slidesOffsetBefore: 32,
    slidesOffsetAfter: 32,
  },
  325: {
    slidesPerView: 1.2,
    spaceBetween: 0,
    slidesOffsetBefore: 16,
    slidesOffsetAfter: 16,
  },
};
export default function Values() {
  return (
    <div className="bg-[#E9E7DE] w-full py-16">
      <Carousel
        slidesPerView={3.4}
        spaceBetween={30}
        loop={false}
        className="featureCarousel w-full my-8"
        breakpoints={breakpoints}
        navigation={true}
        pagination={false}
        showNavAbove={true}
        title="Our Values"
      >
        {data.map((post, key) => (
          <SwiperSlide key={"Post" + key}>
            <Post data={post} />
          </SwiperSlide>
        ))}
      </Carousel>
    </div>
  );
}
const Post = ({ data }) => {
  const { title, id, description } = data;
  return (
    <div className="flex flex-col w-full pl-5 border-l-[0.5px] border-darkGrey/50">
      <span className="text-darkGrey/30 text-sm">{id}</span>
      <papn className="font-havletica text-darkGrey font-light lg:text-2xl text-lg">
        {title}
      </papn>
      <span className="!text-darkGrey/70 font-light text-[14px] leading-tight lg:max-w-[305px]">
        {description}
      </span>
    </div>
  );
};
